import {Component, Input} from '@angular/core';


@Component({
    selector: 'payment-icons',
    templateUrl: './payment.icons.component.html'
})
export class PaymentIconsComponent {
    @Input() icon: string;
}
